//* 组件库
import type { UiTypes } from "various-ui";

export interface ModuleCodonContrast {
    end: number;
    start: number;
    codon: string;
    readonly: boolean;
}

export interface ModuleTranscript extends UiTypes.candidate {
    cds: number[][];
    name: string;
    label: string;
    value: string;
    exons: number[][];
}

export interface ModuleTranscriptContrast {
    site: number;
    char: string;
}

export type ModuleFormData = ModuleFormVariantData | ModuleFormProteinData | ModuleFormTranscriptData;

export interface ModuleFormBaseData {
    key: number;
    id: string;
    ref: string;
    alt: string;
    name: string;
    species: string;
    visible: boolean;
    sequence: string;
    transcript: string;
    transcripts: ModuleTranscript[];
}

export interface ModuleFormVariantData extends ModuleFormBaseData {
    mode: "Paste" | "Variant";
    data: {
        mode?: string;
        range?: { start: number; end: number };
        codons?: string[];
        keyword: string;
    };
}

export interface ModuleFormProteinData extends ModuleFormBaseData {
    mode: "Protein";
    data: {
        site: number | string;
        range?: { start: number; end: number };
        codons?: string[];
        contrast: { [name: number | string]: ModuleCodonContrast | undefined };
    };
}

export interface ModuleFormTranscriptData extends ModuleFormBaseData {
    mode: "Transcript";
    data: {
        coordinate: { "start"?: number; "end"?: number; "end-steps"?: number; "start-steps"?: number };
        contrast: { [name: number | string]: ModuleTranscriptContrast | undefined };
        range?: { start: number; end: number };
    };
}

export const ModulePropsOption = {
    mode: { type: String as PropType<"Pathogenicity" | "RNA Splicer">, require: true },
    explain: { type: Boolean as PropType<boolean>, default: true },
    species: { type: Array as PropType<("Human" | "Mouse" | "Rat")[]> },
} as const;

export type ModuleProps = ExtractPropTypes<typeof ModulePropsOption>;
export const ModuleEmits = {
    info: () => true,
    video: () => true,
    image: () => true,
    submit: (_: { datas: ModuleFormData[]; syns: boolean }) => true,
};
